import { render, staticRenderFns } from "./ActivitiesOverviewSellingCoins.vue?vue&type=template&id=38a3de47&scoped=true&"
import script from "./ActivitiesOverviewSellingCoins.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesOverviewSellingCoins.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesOverviewSellingCoins.vue?vue&type=style&index=0&id=38a3de47&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3de47",
  null
  
)

export default component.exports